import { componentWithClass } from 'lp-utils'

const Content = componentWithClass('main', 'content')

export default Content